/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_RestoreInputs */

const zh_subscription_restore = /** @type {(inputs: Subscription_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复订阅`)
};

const en_subscription_restore = /** @type {(inputs: Subscription_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore Subscription`)
};

const es_subscription_restore = /** @type {(inputs: Subscription_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar suscripción`)
};

/**
* | output |
* | --- |
* | "Restore Subscription" |
*
* @param {Subscription_RestoreInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const subscription_restore = /** @type {((inputs?: Subscription_RestoreInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_RestoreInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_restore(inputs)
	if (locale === "en") return en_subscription_restore(inputs)
	return es_subscription_restore(inputs)
});